<h1 mat-dialog-title>Informação Solicitada</h1>
<div mat-dialog-content>
  <p>Obrigada pelo interesse. Avisaremos assim que os dados desta escola forem atualizados.</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="'Ok'" cdkFocusInitial>Ok</button>
</div>
